import {Spine} from '@fantasmagames/core/src/spine/Spine';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import Container = PIXI.Container;
import SpineSprite = PIXI.spine.SpineSprite;
import TextureAtlasRegion = PIXI.spine.core.TextureAtlasRegion;

export class GameUtils {
	public static randomInt(min: number, max: number): number {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	public static findContainerInSpineByChildName(spine: Spine, childName: string): Container {
		for (const child of spine.children) {
			if (child instanceof Container) {
				const spineSprite: SpineSprite = (child as Container).children[0] as SpineSprite;
				if (spineSprite && spineSprite.region && (spineSprite.region as TextureAtlasRegion).name === childName) {
					return child as Container;
				}
			}
		}

		return null;
	}

	public static shuffleArray(array: any): void {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			const temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	}

	public static radToDeg(rad: number): number {
		return (rad * 180) / Math.PI;
	}

	public static degToRad(deg: number): number {
		return (deg * Math.PI) / 180;
	}

	public static normalize(val: number, max: number, min: number): number {
		return (val - min) / (max - min);
	}

	public static clamp(val: number, min: number = 0, max: number = 1): number {
		return Math.min(max, Math.max(min, val));
	}

	public static getDistanceBetween(pt1: Position, pt2: Position): number {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	}

	/** Linear interpolation */
	public static lerp(start: number, end: number, fraction: number): number {
		return start * (1.0 - fraction) + end * fraction;
	}

	public static correctSpriteScale(sprite: PIXI.Text | PIXI.Sprite, maxSize: Position, maxScale: number = 1): void {
		const newScale: number = 1 / Math.max(maxScale, Math.max(sprite.width / maxSize.x, sprite.height / maxSize.y));
		const oldScale = sprite.scale;

		sprite.scale.set(oldScale.x * newScale, oldScale.y * newScale);
	}

	public static truncateValue(base: number, decimals: number): number {
		const power = Math.pow(10, decimals);

		return Math.trunc(base * power) / power;
	}

	public static isInteger(num: number): boolean {
		return Math.round(num) === num;
	}

	public static getFloatingNumbersPowerOfTen(num: number): number {
		let powerOfTen = 1;

		while (!GameUtils.isInteger(num)) {
			num *= 10;
			powerOfTen *= 10;
		}

		return powerOfTen;
	}

	public static unixDateToSeconds(date: string): number {
		const serverTimeParts: string[] = date.split(/[- :]/);

		return new Date(
			Number.parseInt(serverTimeParts[0], 10),
			Number.parseInt(serverTimeParts[1], 10),
			Number.parseInt(serverTimeParts[2], 10),
			Number.parseInt(serverTimeParts[3], 10),
			Number.parseInt(serverTimeParts[4], 10),
		).getTime();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/utils/GameUtils.ts